export default __webpack_public_path__ + "static/media/assign_pc.fe3dfc82.svg";